export default "__VITE_ASSET__IHLjQoi8__"